import { render } from "./Item.vue?vue&type=template&id=9c603b24&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=9c603b24&lang=scss"
import "./Item.vue?vue&type=style&index=1&id=9c603b24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c603b24"],['__file',"src/common/components/Sidemenu/Item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c603b24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c603b24', __exports__)) {
    api.reload('9c603b24', __exports__)
  }
  
  module.hot.accept("./Item.vue?vue&type=template&id=9c603b24&scoped=true", () => {
    api.rerender('9c603b24', render)
  })

}


export default __exports__